<template>
    <!-- 物料基础数据查看、导出Atos需要的视图、物料变更发起 -->
    <div>
        <div class="app-title">
            <em-view-title :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section v-menu-permission="'list'" class="app-content">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" aria-labelledby="headingOne" class="collapse show"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter ref="emListFilter"
                                           $_em-custom-vuex-mixin_filter="sithMesMstMaterialBasicFilter"
                                           $_em-custom-vuex-mixin_vo="sithMesMstMaterialBasicVo"
                                           :entity="modelName" query-api="findBasicByFilter"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="sithMesMstMaterialResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" aria-labelledby="headingTwo" class="collapse show"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table ref="emTable"
                                      $_em-custom-vuex-mixin_filter="sithMesMstMaterialBasicFilter"
                                      $_em-custom-vuex-mixin_vo="sithMesMstMaterialBasicVo"
                                      :entity="modelName" query-api="findBasicByFilter"
                                      :importEnabled=true
                                      :inlineActionsDisabled="prop_inline!=='1'"
                                      header-btn-edit-disabled
                                      enable-field-batch-edit
                                      accept-batch-edit-fields="plant,bunit,individualColl,engDescription"
                                      with-custom-row-actions-first-column
                                      @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow"
                                      @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow">
                                <template #left-header>
                                    <b-button variant="outline-primary" :disabled="$_notCheckedOne"
                                              @click="$refs.upload.show()">
                                        <i class="fa-solid fa-file-arrow-up"></i> 上传图纸
                                    </b-button>
                                </template>
                                <template #right-header>
                                    <b-button-group>
                                        <em-button :busy="deleteAllLoading" class="btn btn-outline-primary"
                                                   confirm-text="确认清除所有记录吗？"
                                                   custom-icon="fa fa-fw fa-lg fa-solid fa-eraser"
                                                   custom-label="Clear"
                                                   type="edit"
                                                   @click="deleteAllInBatch">
                                        </em-button>
                                        <em-button :busy="doReadLoading" class="btn btn-outline-primary"
                                                   confirm-text="确认读取文件并更新吗？"
                                                   custom-icon="fa-solid fa-arrows-rotate"
                                                   custom-label="UPDATE" show-name
                                                   type="edit"
                                                   @click="doReadMaterialFiles">
                                        </em-button>
                                    </b-button-group>
                                </template>
                                <template #customRowActionsFirstColumn="{row}">
                                    <b-button-group>
                                        <em-button type="downloadFile"
                                                   :busy="requestNewLoading&&requestNewMaterial===row.material"
                                                   :disabled="requestNewLoading"
                                                   custom-label="请求SAP工程图"
                                                   custom-icon="fa fa-solid fa-cloud-arrow-down"
                                                   class="btn btn-outline-primary btn-sm"
                                                   @click="requestNew(row.material)">
                                        </em-button>
                                        <em-button type="downloadFile"
                                                   custom-label="查看图纸列表"
                                                   custom-icon="fa fa-solid fa-folder-open"
                                                   class="btn btn-outline-primary btn-sm"
                                                   @click="gotoDrawingPage(row)">
                                        </em-button>
                                    </b-button-group>
                                </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
        <b-modal id="modal-updateMaterial" hide-footer title="导入物料主数据">
            <b-form @reset="handleReset" @submit="handleSubmit">
                <b-form-group
                    id="templateFile"
                    invalid-feedback="必须选择数据源"
                    label="选择数据源文件:"
                    label-for="input-dataFile">
                    <b-form-file id="input-dataFile" ref="file-input" v-model="file"
                                 :browse-text="$t('btn.basic.browse')"
                                 :file-name-formatter="formatNames" accept=".xlsx"
                                 class="mb-2" placeholder="请选择数据文件" required></b-form-file>
                </b-form-group>

                <div class="form-check mt-2">
                    <input id="agreement" aria-describedby="invalidCheckFeedback" class="form-check-input is-invalid"
                           required
                           type="checkbox" value="">
                    <label class="form-check-label" for="agreement">确认覆盖原始数据</label>
                    <div id="invalidCheckFeedback" class="invalid-feedback">请确认</div>
                </div>

                <b-row align-h="end" style="margin-top: 30px">
                    <b-button type="submit" variant="primary">导入</b-button>
                    <b-button type="reset" variant="light">取消</b-button>
                </b-row>
            </b-form>
        </b-modal>

        <drawing-upload ref="upload" :material="checkedRow?checkedRow.material:null"></drawing-upload>
    </div>
</template>
<script>
// Author Lin
// Date 2021-03-18 15:27:45

import emCommonListMixin from "@/mixin/em/common/list";
import emCommonApiMixin from "@/mixin/em/common/api";
import commonViewsUtil from "@/utils/commonViewsUtil";
import emTableCheckedMixin from "@/mixin/em/common/stuffs/table/emTableCheckedMixin";
import DrawingUpload from "@/views/sithMesII/pds/stuffs/DrawingUpload.vue";

export default {
    name: "sithMesMstMaterialListView",
    components: {DrawingUpload},
    mixins: [emCommonListMixin, emCommonApiMixin, emTableCheckedMixin],
    props: {
        //是否启用行编辑
        prop_inline: {
            type: String,
            default: "0"
        }
    },
    data() {
        return {
            file: null,
            deleteAllLoading: false,
            requestNewLoading: false,
            requestNewMaterial: null,
            doReadLoading: false,
        }
    },
    computed: {
        modelName() {
            return 'sithMesMstMaterial'
        },
        $_customVuexName() {
            return 'sithMesMstMaterialBasic';
        },
        pathType() {
            return this.$route.query.pathType;
        },

    },
    methods: {
        formatNames(files) {
            return files.length === 1 ? files[0].name : `${files.length} files selected`
        },
        handleSubmit(event) {
            let self = this;
            event.preventDefault()
            var formData = new FormData();
            formData.append('file', this.file);

            this.$_emApiMixin_post(`${this.$_emApiMixin_entityBaseApi(this.modelName)}/updateData`, formData)
                .then(response => {
                    commonViewsUtil.showSuccess(this, "更新成功")
                    self.$refs.emListFilter.doQuery()
                })

            this.$nextTick(() => {
                this.$bvModal.hide('modal-updateMaterial')
            })
        },
        handleReset() {
            this.selectedMachineType = null;
            this.file = null;
            this.$nextTick(() => {
                this.$bvModal.hide('modal-updateMaterial')
            })
        },
        deleteAllInBatch() {
            this.deleteAllLoading = true;
            this.$store.dispatch('api/post', {
                url: process.env.VUE_APP_SITHMES_MST_URL + "/sithMesMstMaterial/deleteAll",
                data: {}
            }).then(() => {
                this.$message.success("operation success");
                this.$refs.emListFilter.doQuery();
            })
                .finally(() => this.deleteAllLoading = false);
        },
        doReadMaterialFiles() {
            if (this.doReadLoading) {
                return;
            }
            this.doReadLoading = true;
            this.$store.dispatch('api/post', {
                url: process.env.VUE_APP_EM_ASSISTANT_URL + "/xxlJobController/run?taskCode=doReadMaterialFiles",
                data: {}
            }).then(() => this.$message.success('执行任务创建成功，请稍后查看'))
                .finally(() => this.doReadLoading = false);
        },
        //----drawing----
        requestNew(material) {
            this.requestNewLoading = true;
            this.requestNewMaterial = material;
            this.$store.dispatch('api/post', {
                url: process.env.VUE_APP_SITHMES_II_URL + "/materialDrawing/request/new?material=" + material,
                data: {}
            }).then(() => {
                this.$message.success("request success");
            }).finally(() => this.requestNewLoading = false);
        },
        gotoDrawingPage(row) {
            this.$router.push({
                name: 'sithMomMaterialDrawingInfoList',
                query: {
                    material: row.material
                }
            })
        },
    },
    mounted() {
    }
};
</script>
